import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


// import all Model Objects and Intefaces Goes here...
import { ValidationUtils } from 'src/app/shared/utils/validation.utils';
import { Bulletin } from '../../core/models/bulletin';


@Injectable()
export class BulletinService {

  private bulletins: Bulletin[];
  // private endpointURL = "http://localhost:8080/serviceBulletin/new";

  private serviceBulletinFilter: string;

  private endpointURL = 'serviceBulletin/all';
  private endpointURL_newBulletins = 'serviceBulletin/new';
  private endpointURL_recentBulletins = 'serviceBulletin/all';
  private shouldSave: boolean = false;
  private filter: {};
  private mainGroupString: string;
  private inputSeries: string;
  private inputToYear: string;
  private inputFromYear: string;

  private allSIBs: any;

  constructor(private http: HttpClient) { }

  /** GET Bulletin from the server */

  getAllBulletinService(): Observable<any> {
    return this.http.get(this.endpointURL);
  }

  getNewBulletinService(): Observable<any> {
    return this.http.get(this.endpointURL_newBulletins);
  }

  getRecentBulletinService(): Observable<any> {
    return this.http.get(this.endpointURL_recentBulletins);
  }

  getHistoryBulletinService(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/sibHistorylist`);
  }

  // add user visited bulletin to his history
  addBulletinToUserHistory(userId, id) {
    return this.http.post(`user-info/qID/${userId}/addSIBToHistorylist/${id}`, {withCredentials : true});
  }


  // fetch user saved Service bulletins
  getUserSavedServieBulletins(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/sib/userSavedBulletinGroupCategory`);
  }

  // check whether if given bulletin number is saved
  getBulletinData(userId, bulletinType, bulletinNumber): Observable<any> {
    const sanitizedUserId = ValidationUtils.sanitizeQID(userId);
    const sanitizedBulletinType = ValidationUtils.sanitizeRemoveSymbols(bulletinType);
    const sanitizedBulletinNumber = ValidationUtils.sanitizeRemoveSymbols(bulletinNumber);
    return this.http.get(`user-info/qID/${sanitizedUserId}/findOneUserSavedBulletin/${sanitizedBulletinType}/${sanitizedBulletinNumber}`);
  }

  // bulletin-detail
  getBulletinInfo(bulletinId, type): Observable<any> {
    if (type === 'tri') {
      return this.http.get(`tri-bulletin/findMoreBulletinDetail/bulletinNumber/${bulletinId}`);
    }else if (type === 'sib') {
      return this.http.get(`serviceBulletin/findMoreBulletinDetail/bulletinNumber/${bulletinId}`);
    }else if (type === 'pbs') {
      return this.http.get(`serviceBulletin/findMoreBulletinDetail/bulletinNumber/${bulletinId}`);
    }
  }
  saveBulletin(userId, bulletinType, bulletinNumber): Observable<any> {
    const sanitizedUserId = ValidationUtils.sanitizeQID(userId);
    const sanitizedBulletinType = ValidationUtils.sanitizeQID(bulletinType);
    const sanitizedBulletinNumber = ValidationUtils.sanitizeQID(bulletinNumber);
    return this.http.post(`user-info/qID/${sanitizedUserId}/addBulletinToSavedBulletinGroup/${sanitizedBulletinType}/${sanitizedBulletinNumber}`, '');
  }
  unSaveBulletin(userId, bulletinNumber): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/deleteUserSavedBulletin/${bulletinNumber}`);
  }

  saveFilterData(filter: string) {
    this.serviceBulletinFilter = filter;
  }

  getFilterData(): string {
    return this.serviceBulletinFilter;
  }

  saveLeftHandFilterBoolean(save: boolean) {
    this.shouldSave = save; 
  }

  saveLeftHandFilterObject(filter: {}, mainGroup: string, inputSeries: string, inputFromYear: string, inputToYear: string) {
    this.filter = filter;
    this.mainGroupString = mainGroup;
    this.inputSeries = inputSeries;
    this.inputFromYear = inputFromYear;
    this.inputToYear = inputToYear;
  }

  getLeftHandFilterObject(): {} {
    return this.filter;
  }

  getLeftHandFilterBoolean(): boolean {
    return this.shouldSave;
  }

  getLeftHandFilterMainGroupString(): string {
    return this.mainGroupString;
  }

  getLeftHandFilterInputSeries(): string {
    return this.inputSeries;
  }

  getLeftHandFilterFromYear(): string {
    return this.inputFromYear;
  }

  getLeftHandFilterToYear(): string {
    return this.inputToYear;
  }


}
